import { userSelector } from 'slices/auth.slice';
import { useAppSelector } from 'slices/store';
import { TOperationType } from 'types/objectJob.type';
import { getVisibility } from 'utils/authentication';

const operationPermissionMap: Partial<
  Record<TOperationType, { permissions: string[] }>
> = {
  EXPORT: {
    permissions: ['TE_ADMIN::exportObjects'],
  },
  IMPORT: {
    permissions: ['TE_ADMIN::importObjects'],
  },
};

export const useOperationPermission = (operation: TOperationType) => {
  const authUser = useAppSelector(userSelector);

  const hasPermission = getVisibility({
    authUser,
    minimumPermissions: operationPermissionMap[operation] ?? {
      permissions: ['TE_ADMIN::manageObjects'],
    },
  });

  return hasPermission;
};
